import logger from './logger';

const DEFAULT_GEN_PREFIX = (unit: string) => `[${unit}] `;

/** Wrapper for logger, adding a prefix with the unit (just a string) in square
 * brackets to each message */
export default class UnitLogger {
  prefix: string;

  enabled: boolean;

  /**
   * @param unit - The section/component/whatever to use in prefix
   * @param enabled - start enabled
   * @param genPrefix - Override the default `[${unit}] ` prefix
   * @returns  A wrapper for our logger
   */
  constructor(unit: string, enabled = true, genPrefix = DEFAULT_GEN_PREFIX) {
    this.enabled = enabled;
    this.prefix = genPrefix(unit);
  }

  setEnabled(enabled: boolean) {
    this.enabled = enabled;
  }

  log(msg: string, ...args: unknown[]) {
    if (this.enabled) logger.log(`${this.prefix}${msg}`, ...args);
  }

  debug(msg: string, ...args: unknown[]) {
    if (this.enabled) logger.debug(`${this.prefix}${msg}`, ...args);
  }

  error(msg: string, ...args: unknown[]) {
    if (this.enabled) logger.error(`${this.prefix}${msg}`, ...args);
  }

  warn(msg: string, ...args: unknown[]) {
    if (this.enabled) logger.warn(`${this.prefix}${msg}`, ...args);
  }

  info(msg: string, ...args: unknown[]) {
    if (this.enabled) logger.info(`${this.prefix}${msg}`, ...args);
  }
}
